import { Box } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import { usePage } from 'contexts/Page/Page';
import * as setup from 'setup';
import Budgets from '../Budgets/Budgets';
import CommunityCards from '../CommunityCards/CommunityCards';
import FoldButton from '../FoldButton/FoldButton';
import GameCardButton from '../GameCardButton/GameCardButton';
import HoleCards from '../HoleCards/HoleCards';
import Opponents from '../Opponents/Opponents';
import Pots from '../Pots/Pots';
import ResultImage from '../ResultImage/ResultImage';
import RewindButton from '../RewindButton/RewindButton';
import WinPercentage from '../WinPercentage/WinPercentage';

export default function GameTable({ center, compact }: GameTableProps) {
    const game = useGame();
    const page = usePage();

    return (
        <Box
            alignItems="center"
            color="#FFF"
            display="flex"
            flexDirection={compact ? 'row' : 'column'}
            gap={3}
            paddingX={compact ? 0 : 5}
            paddingY={2}
        >
            {compact && (
                <Box alignItems="flex-end" display="flex" gap={1} paddingTop={1.25}>
                    <ResultImage />
                    <HoleCards />
                </Box>
            )}

            {!compact && <Opponents />}

            <Box display="flex" justifyContent="center" position="relative">
                {!compact && (
                    <Box
                        alignItems="center"
                        display="flex"
                        height="100%"
                        marginRight={1}
                        position="absolute"
                        right="100%"
                        top={0}
                    >
                        <ResultImage />
                    </Box>
                )}
                <CommunityCards compact={compact} />
                {!compact && <Pots compact={!center} />}
            </Box>

            {!compact && (
                <Box alignItems="flex-start" display="flex" justifyContent="center" gap={6}>
                    <Box
                        alignItems="flex-end"
                        display="flex"
                        flexDirection="column"
                        gap={1}
                        justifyContent="center"
                        marginTop={5}
                        width={200}
                    >
                        <WinPercentage />
                        {(page.lessonParent >= 2 || game.lessonProps.rewindButtonLesson) && <RewindButton />}
                    </Box>

                    <Box>
                        <Box position="relative">
                            <HoleCards />
                            <GameCardButton
                                cost={setup.cards.holeCost}
                                round="hole"
                                staticWidth={94}
                                tabIndex={1}
                                type="payHole"
                            />
                        </Box>
                        {page.lessonParent >= 2 && !game.lessonProps.hideFoldButton && <FoldButton />}
                    </Box>

                    <Box marginTop={5} width={200}>
                        <Budgets />
                    </Box>
                </Box>
            )}
        </Box>
    );
}
